import React from "react";
import Logo from "../../components/common/Logo";
import { ArrowLeft } from "lucide-react";

function DemoSession() {
    return (
        <>
            
                <div className="min-h-screen bg-[#F4EFE8] px-4 md:px-10 py-6">      {/* LOGO */}
                    <div className="mb-8">
                        <Logo />
                    </div>

                    {/* TOP BAR */}
                    <div className="bg-primary rounded-md h-[70px] flex items-center justify-between px-6 md:px-8">

                        <h2 className="text-white text-[24px] md:text-[40px] font-semibold">
                            Sample Session Class
                        </h2>

                        <button>
                            <ArrowLeft
                                size={40}
                                className="text-white"
                            />
                        </button>

                    </div>
                </div>
        </>
    )
}
export default DemoSession;